<template>
    <div class="carousel-sheet-container">
        <div class="container" v-if="Object.keys(current_patient_data).length" id="table-container">
            <Table_SNV :preferSelected="true" :showSelectColumn="false" :usePatientData="true" :maxHeight="max_height" id="variant-table" table_id="mtb_snv_table"/>
        </div>
        <Icon icon="mdi:dna" width="200" height="200"  color="#3d5afe" v-if="!Object.keys(current_patient_data).length > 0 && !selected_variants.length > 0"/>
        <p v-if="!Object.keys(current_patient_data).length > 0 && !selected_variants.length > 0">Variant data for the patient (if previously added) would be shown here.</p>
    </div>
</template>

<script setup lang="js">
import Table_SNV from "@/components/tables/Table_SNV.vue";
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { Icon } from '@iconify/vue';
const store = useStore();
const current_patient_data = computed(() => store.getters.biomarkersForCurrentPatient);
const selected_variants = computed(() => store.state.presentation_selected_variants);

onMounted(() => {
    max_height.value = document.getElementById('table-container')?.getBoundingClientRect().height;
})

const max_height = ref(900);
</script>

<style scoped>

.container {
    width: 100%;
    height: 100%;
    margin-top: 32px;
    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.container::-webkit-scrollbar {
    display: none; /* Safari, Chrome, Opera */
}

</style>